import { isWeb } from '@volt-libs/foundation'

const production = {
    env: 'production',
    supportedLanguages: ['en', 'ar'],
    urls: {
        authUrl: 'https://edsprod.ott.ooredoo.qa:33428',
        authUrlBackup: 'https://edsprodback.ott.ooredoo.qa:33428',
        apiUrl: 'https://vsc2prod.ott.ooredoo.qa:33200',
        apigeeUrl: 'https://prod-01.apigw.ooredoo.qa',
        soloAuthUrl: 'https://prod-01.apigw.ooredoo.qa',
        soloVerifyOtpUrl: 'https://stg-01.apigw.ooredoo.qa',
        signUpUrl: 'https://www.ooredoo.qa/web/en/otv-guide/',
        proxyUrl: 'https://waf-ooredoo-api.ooredootv.qa/maculosa/v3.1',
        emi: {
            baseUrl: 'https://waf-ooredoo-api.ooredootv.qa/emi',
            homePath: `3.0/{population}/${isWeb ? 1 : 3}`,
            defaultPopulation: 'prod',
        },
        reportVulnerabilityUrl: 'https://www.ooredoo.qa/web/en/otv-guide/',
        helpAndFaqUrl: 'https://www.ooredoo.qa/web/en/otv-guide/',
        termsAndConditions: 'https://ooredoo.qa/web/en/general-terms-and-conditions-for-consumer-services/',
        manageSubscriptionURL : "",
        mobileAppTermsAndConditions: 'https://www.ooredoo.qa/web/en/otv-guide/',
        mobilePrivacyPolicy: "https://www.ooredoo.qa/web/en/otv-guide/",
        store: {
            applePhone: 'https://apps.apple.com/sg/app/starhub-tv/id586220439',
            appleTablet: 'http://starhub.com/tvplus-pro-help',
            googlePhone: 'https://play.google.com/store/apps/details?id=com.starhub.itv&hl=en_GB&gl=US',
            googleTablet: 'http://starhub.com/tvplus-pro-help',
            chromeBrowser: 'https://www.google.com/chrome/',
        },
        socialMedia: {
            facebook: "https://www.facebook.com/",
            messanger: "https://www.messenger.com/",
            instagram: "https://instagram.com/",
            youtube: "https://www.youtube.com/",
            twitter: "https://twitter.com/",
        }
    },
    allowGuest: false,
    showTrailer: true,
    eplFeatures : {
        matchStatistics: false,
        matchEvents: false,
        multiCamValue: 0, // 0: Not supported, 1: Supported single view, 2: Supported multi view, here 2 views at a time,...
    },
    showRentSubscription: true,
    proxyVersion: 3,
    voltPlayer: {
        drmConfig: {},
        mediaEngine: 'shaka',
    },
    ooredoo: {
        clientId: 'KIbxyh8sTA',
        userAgent: 'OoredooApigw',
        clientKey: 'ROxxbm8XP8VugKJY84ILitNFAv0bXDMl3q021A5PSlJeYh0P',
        clientSecret: '7c5g3iT5aP1OWtRieAFE2lXTsHhNG1eXTGL7egbq5GDsULXYX1pl9YrLC2mW2Gtb',
        lmsEnvironment: 'OQ_NG_RES',
        soloToken: "UFdieEdGOTZiNENkZVJnQWpNelZPRzBNZnM0S2dyc1ROZWJXcVFLZ2NvR0dQdnJiOjd6ZG5xa2ozTXFLeElOYzFhY0lnOUdsSHFEQUNDTEM3MDZvU0t4QURIQXkwMVVHOUUxTng5QzN0WWJrY3pMRXo=",
        phoneNumberVisibleDigits: 4, // to get obfuscated phone numbers
        // For debug purposes (TODO: to be removed later)
        // To be removed for official delivery
        // forceIptvAccountNumber: '2110060837641',
        // debugValidateOTP: '0000',
    },
    huawei: {
        // Parameter to use V2 API for login as it enables feature like Silent Login for STB
        useLoginApiV2: false,
        // Use Api V2 for rest(other than authenticate api) of the communication for example addProfile, queryProfile... etc.
        // False means it will use api version V3.
        useApiVersionV2: false,
        // useVspHttpsUrl: This parameter allows to use the VSP HTTPs URL returned by the load balancer
        useVspHttpsUrl: true,
        // This parameter is to force manual management of the cookies for Authorization. Can be used only for react native applications. Brower are not compatible
        forceSessionCookieHeader: false, //TODO: set to true for smartTV
        // This parameter if for forcing the fetch of the products from IFS proxy is equals to true. Otherwise Huawei backend is directly used
        useProxyProducts: false,
        // When starting a playback session, indicate if the manifest URL should be HTTP or HTTPs
        useHttpsStream: true,
        // This paramater is used to force an error when the 'authToken' from the login is not receiced. authToken is used for auto relogin after reboot
        loginErrorWhenAuthTokenIsMissing: false,
        // Defined the currency of TVOD Products
        TvodCurrency: 'QAR',
        // Defined the currency of the Packs
        SubscriptionCurrency: 'Credit',
        // This parameter reduces by a factor the refresh heartbeat for increasing the refreshing rate
        heartbeatNextIntervalReducedBy: 2,
        // Nb of attempts to recover a session using login from token method before stopping
        maxRecoverFromRefreshHeartbeatFailure: 3,
        // This paramter is a debug mode for forcing the mac address
        forceMacAddressPattern: false,
        // This paramter is a debug mode for allowing login attempts if serial number is missing
        allowLoginRequestIfSerialNumberMissing: false,
        // Purchase using user password rather than purchase pin
        purchaseUsingUserPassword: true,
        // Timeout for /EDS/V3/LoginRoute request related to operator network connection checking, ms
        operatorConnectionCheckTimeout: 10000,
    },
    firebaseConfig: {
        enabled: true,
        apiKey: "AIzaSyCd8IRNiIk9RpOnQpDy7l1mRpz2Dd7eCNg",
        authDomain: "ooredoo-tv-fb0fb.firebaseapp.com",
        projectId: "ooredoo-tv-fb0fb",
        storageBucket: "ooredoo-tv-fb0fb.firebasestorage.app",
        messagingSenderId: "489446849034",
        appId: `${isWeb ? '1:489446849034:web:d9f2579436e282e857fdf3' : '1:489446849034:web:f176ab470f1d617257fdf3'}`,
        measurementId: `${isWeb ? 'G-130K3FQXFX' : 'G-VN2WRP8CKV'}`
    },
    gfkAnalytics: {
        enable: false,
        contentId: 'Linear',
        streamId: 'StarhubTizenTV',
        mediaId: 'StarhubTizenTV',
        sdkJsonUrl: 'https://sg-config.sensic.net/s2s-android.json',
        url: 'https://sg-config.sensic.net/ctv/s2s-web.js',
        media: 's2s-html5-demo',
        type: 'TV',
        device: 'SMART-TV',
        logLevel: 'none',
    },
    authenticationType: 'solo',
    authenticationTypeTv: ['solo'],
    agama: {
        // Agama analytics status
        enable: true,
        //Console URI
        _configuration:"emp_service=https://aggregation.ott.ooredoo.qa:8192/report;report_interval=240;id_report_interval=4800;operator_id=Ooredoo_0x5E01_VLTN;",
         // player name
        playerName: 'Shaka Player',
        playerVersion: '4.3.8-nmp-2',
        caSystem: 'PlayReady',
        cdn: 'Huawei',
        //DEBUG for development and INFO for Prod.
        verbose:'Agama.LogLevel.FATAL'
    },
    hybridHeight: isWeb ? '135px': '250px',
    heroSliderAutoplay : isWeb ? false : false,
    watermark: {
        enabled: true,
        strength: 70
    }
}

export default production
